export default __webpack_public_path__ + "static/media/Helm of the Defiant.330ab55e.jpg";